import { Box, Grid } from '@chakra-ui/react'

import DesignCard from './design-card'

import type { Design } from '@/api/designs'

interface SymmetricGridProps {
  designs: Design[]
  onImageClick: (design: Design) => void
  onToggleFavorite: (designId: string, isFavorite: boolean) => void
}

export default function SymmetricGrid({
  designs,
  onImageClick,
  onToggleFavorite
}: SymmetricGridProps) {
  return (
    <Box px={{ base: '16px', md: '24px' }}>
      <Grid
        templateColumns={{ base: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' }}
        gap="20px"
      >
        {designs.map((design, index) => (
          <DesignCard
            key={design.id}
            design={design}
            index={index}
            columnsPerRow={4}
            layoutMode="grid"
            onImageClick={onImageClick}
            onToggleFavorite={onToggleFavorite}
          />
        ))}
      </Grid>
    </Box>
  )
}
